// removed by extract-text-webpack-plugin
module.exports = {"Container":"Table__Container__3E3qq","Table":"Table__Table__3HT1h","Odd":"Table__Odd__1k0I2","Selected":"Table__Selected__1E2j4","Footer":"Table__Footer__2y151","Legend":"Table__Legend__147Ow"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Table/Table.css
// module id = 186
// module chunks = 2